import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { styled, useFormControl, InputLabel, FormLabel } from '@mui/material';
import { createComponentSlot } from '../../modules/styling/theme.js';

var _excluded = ["startAdornment", "endAdornment", "adornmentSpacing", "className", "sx", "variant", "children"];
var componentLabel = createComponentSlot({
  name: "CinForm",
  slot: "Label"
});
var componentStartAdornment = createComponentSlot({
  name: "CinForm",
  slot: "StartAdornment"
});
var componentEndAdornment = createComponentSlot({
  name: "CinForm",
  slot: "EndAdornment"
});

var FieldLabelBase = function FieldLabelBase(_ref) {
  var _props$required;

  var startAdornment = _ref.startAdornment,
      endAdornment = _ref.endAdornment;
      _ref.adornmentSpacing;
      var className = _ref.className;
      _ref.sx;
      var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "field" : _ref$variant,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var formControl = useFormControl();

  if (variant === "input") {
    // adornment/wrapper not supported on dynamically positioned input labels
    return /*#__PURE__*/React.createElement(InputLabel, props, children);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames(componentLabel.className, className)
  }, startAdornment && /*#__PURE__*/React.createElement("span", {
    className: componentStartAdornment.className
  }, startAdornment), variant === "form" ? /*#__PURE__*/React.createElement(FormLabel, props, children) : variant === "field" ? /*#__PURE__*/React.createElement(InputLabel, _extends({}, props, {
    shrink: true,
    variant: "standard"
  }), children) : /*#__PURE__*/React.createElement(React.Fragment, null, children, ((_props$required = props.required) !== null && _props$required !== void 0 ? _props$required : formControl === null || formControl === void 0 ? void 0 : formControl.required) && /*#__PURE__*/React.createElement("span", null, "\u2009*")), endAdornment && /*#__PURE__*/React.createElement("span", {
    className: componentEndAdornment.className
  }, endAdornment));
};
/**
 * Displays a label for a form field
 */


FieldLabelBase.propTypes = {
  startAdornment: propTypes.node,
  endAdornment: propTypes.node,
  adornmentSpacing: propTypes.oneOfType([propTypes.number, propTypes.string]),
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
};
var FieldLabel = styled(FieldLabelBase, _objectSpread2(_objectSpread2({}, componentLabel.styledOptions), {}, {
  skipVariantsResolver: true
}))(function (_ref2) {
  var _objectSpread2$1;

  var theme = _ref2.theme,
      startAdornment = _ref2.startAdornment,
      endAdornment = _ref2.endAdornment,
      _ref2$adornmentSpacin = _ref2.adornmentSpacing,
      adornmentSpacing = _ref2$adornmentSpacin === void 0 ? 2 : _ref2$adornmentSpacin,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? "field" : _ref2$variant;
  return _objectSpread2(_objectSpread2(_objectSpread2({
    marginBottom: variant !== "text" ? theme.spacing(0.25) : undefined
  }, variant === "field" && {
    "> .MuiInputLabel-root": {
      position: "relative",
      transform: "none",
      fontSize: "0.75rem",
      lineHeight: "1rem"
    }
  }), (startAdornment || endAdornment) && {
    display: "flex",
    alignItems: "center"
  }), {}, (_objectSpread2$1 = {}, _defineProperty(_objectSpread2$1, "> .".concat(componentStartAdornment.className), {
    display: "flex",
    marginRight: typeof adornmentSpacing === "number" ? theme.spacing(adornmentSpacing) : adornmentSpacing
  }), _defineProperty(_objectSpread2$1, "> .".concat(componentEndAdornment.className), {
    display: "flex",
    marginLeft: typeof adornmentSpacing === "number" ? theme.spacing(adornmentSpacing) : adornmentSpacing
  }), _objectSpread2$1));
});
var FieldLabel$1 = FieldLabel;

export { FieldLabel$1 as default };
